import { render, staticRenderFns } from "./omsetkota_list.vue?vue&type=template&id=6d8d7241"
import script from "./omsetkota_list.vue?vue&type=script&lang=js"
export * from "./omsetkota_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports